import OrderDetail from 'components/RichProfile/MyAccount/OrderDetail/OrderDetail';
import { withOrderDetailProps } from 'viewModel/richProfile/myAccount/orderDetail/withOrderDetailProps';

export default withOrderDetailProps(OrderDetail);
